export default __webpack_public_path__ + "static/Gotham-MediumItalic-baf73aa8f41d0155d90a672e47b1f326.woff";